import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Admin from "./pages/Admin";
import Home from "./pages/Home";
import ThankYouPage from "pages/logOut";
import LoginForm from "pages/LoginForm";
import PrivateRoute from "./components/PrivateRoute";
import EuropeanHome from "./pages/EuropeanHome";

export default function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/verify-email" element={<LoginForm />} />
          <Route path="/logout" element={<ThankYouPage />} />
          {/* Private Routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/register" element={<Home />} />
            <Route path="/europregister" element={<EuropeanHome />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}
